const ProductPlacementList = [
  { name: 'on the floor', label: 'on the floor', value: 'on the floor' },
  { name: 'on the ground', label: 'on the ground', value: 'on the ground' },
  { name: 'on the wall', label: 'on the wall', value: 'on the wall' },
  { name: 'on the windowsill', label: 'on the windowsill', value: 'on the windowsill' },
  { name: 'on the table', label: 'on the table', value: 'on the table' },
  { name: 'on the nightstand', label: 'on the nightstand', value: 'on the nightstand' },
  { name: 'on the credenza', label: 'on the credenza', value: 'on the credenza' },
  { name: 'on the vanity table', label: 'on the vanity table', value: 'on the vanity table' },
  { name: 'on the countertop (counter)', label: 'on the countertop', value: 'on the countertop (counter)' },
  { name: 'on the stand', label: 'on the stand', value: 'on the stand' },
  { name: 'on the display case (of the store)', label: 'on the display case', value: 'on the display case (of the store)' },
  { name: 'on the pillow', label: 'on the pillow', value: 'on the pillow' },
];

export default ProductPlacementList;
